import { render, staticRenderFns } from "./Reportetopventa.vue?vue&type=template&id=214e22a1&"
import script from "./Reportetopventa.vue?vue&type=script&lang=js&"
export * from "./Reportetopventa.vue?vue&type=script&lang=js&"
import style0 from "./Reportetopventa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports